
import { supabase } from '@/integrations/supabase/client';

/**
 * Adds a new country to the database
 */
export const addCountry = async (name: string): Promise<void> => {
  const { error } = await supabase.from('countries').insert([{ name }]);
  if (error) throw error;
};
